import { render, staticRenderFns } from "./ArquivosWindowLB.vue?vue&type=template&id=45fb015f&scoped=true&"
import script from "./ArquivosWindowLB.vue?vue&type=script&lang=js&"
export * from "./ArquivosWindowLB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fb015f",
  null
  
)

export default component.exports